var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "1 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2179 8.23333C12.1705 5.51333 8.44145 5.36666 9.34204 1.41333C9.40875 1.12 9.09521 0.89333 8.84171 1.04666C6.42014 2.47333 4.679 5.33333 6.13996 9.08C6.26003 9.38666 5.8998 9.67333 5.63963 9.47333C4.43218 8.56 4.30543 7.24666 4.41216 6.30666C4.45219 5.96 3.99856 5.79333 3.8051 6.08C3.35147 6.77333 2.89117 7.89333 2.89117 9.58C3.14467 13.3133 6.30006 14.46 7.43413 14.6067C9.05519 14.8133 10.8097 14.5133 12.0705 13.36C13.4581 12.0733 13.965 10.02 13.2179 8.23333ZM7.0272 11.5867C7.98782 11.3533 8.48148 10.66 8.6149 10.0467C8.83504 9.09333 7.97448 8.16 8.55486 6.65333C8.775 7.9 10.7363 8.68 10.7363 10.04C10.7896 11.7267 8.96179 13.1733 7.0272 11.5867Z",
    fill: "#EC925E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "97120/static/media/fire.bcd8f2c60514a73c66b4adba09a69fd9.svg";
export { ForwardRef as ReactComponent };